import * as React from 'react';
import classnames from 'classnames';

import './state-statistics-card.scss';

type Props = {
  type?: 'single' | 'double',
  children: React.ReactNode
};

const StateStatisticsCard = (
  {
    type = 'double',
    children
  }: Props
): JSX.Element => {
  const sectionClasses = classnames('state-statistics-card__section', {
    [`state-statistics-card__section--${type}`]: Boolean(type)
  });

  return (
    <div className="state-statistics-card">
      <div className={sectionClasses}>
        {children}
      </div>
    </div>
  );
};

export default StateStatisticsCard;
